/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export interface MessagesProp {
  [key: string]: {
    id: string;
    defaultMessage: string;
  };
}

export const messages: MessagesProp = defineMessages({
  deliveryToLate: {
    id: 'complaints.causes.deliveryToLate',
    defaultMessage: 'Delivery to late',
  },
  notDeliveredOrIncomplete: {
    id: 'complaints.causes.notDeliveredOrIncomplete',
    defaultMessage: 'Shipment not delivered or incomplete delivery',
  },
  doesntMeetExpectations: {
    id: 'complaints.causes.doesntMeetExpectations',
    defaultMessage: 'Doesn\'t meet expectations',
  },
  deliveredDamaged: {
    id: 'complaints.causes.deliveredDamaged',
    defaultMessage: 'Delivered damaged',
  },
  productDamaged: {
    id: 'complaints.causes.productDamaged',
    defaultMessage: 'Product damaged',
  },
  reprint: {
    id: 'complaints.resolutions.reprint',
    defaultMessage: 'Reprint',
  },
  discountCoupon: {
    id: 'complaints.resolutions.discountCoupon',
    defaultMessage: 'Discount Coupon',
  },
  partialRefund: {
    id: 'complaints.resolutions.partialRefund',
    defaultMessage: '(partial) refund',
  },
  success: {
    id: 'complaints.form.complaint.success',
    defaultMessage: 'Complaint added successfully.',
  },
  complaintError: {
    id: 'complaints.form.error',
    defaultMessage: 'Something went wrong while creating complaint.',
  },
  orderError: {
    id: 'complaints.form.order.error',
    defaultMessage: 'Something went wrong while fetching order.',
  },
  causeError: {
    id: 'complaints.form.cause.error',
    defaultMessage: 'Something went wrong while fetching cause options.',
  },
  isComplainableError: {
    id: 'complaints.form.isComplainable.error',
    defaultMessage: 'Something went wrong while determining if the line item is complainable.',
  },
  lineItemNotComplainable: {
    id: 'complaints.form.lineItemNotComplainable.error',
    defaultMessage: 'This line item is not in the state to raise a complaint.',
  },
  solutionError: {
    id: 'complaints.form.solution.error',
    defaultMessage: 'Something went wrong while fetching solution options.',
  },
  lineItemError: {
    id: 'complaint.form.lineItemNotFound',
    defaultMessage: 'Item not found for the selected order.',
  },
  complaintTitle: {
    id: 'complaints.title',
    defaultMessage: 'My Complaints',
  },
  complaintNumberPrefix: {
    id: 'complaints.list.complaintNumberPrefix',
    defaultMessage: 'Complaint',
  },
  new: {
    id: 'complaints.status.new',
    defaultMessage: 'new',
  },
  inProgress: {
    id: 'complaints.status.inProgress',
    defaultMessage: 'in progress',
  },
  waitingForCustomer: {
    id: 'complaints.status.waitingForCustomer',
    defaultMessage: 'waiting for customer',
  },
  resolved: {
    id: 'complaints.status.resolved',
    defaultMessage: 'resolved',
  },
  rejected: {
    id: 'complaints.status.rejected',
    defaultMessage: 'resolved',
  },
  cancelled: {
    id: 'complaints.status.cancelled',
    defaultMessage: 'cancelled',
  },
  backToComplaintsOverviewPage: {
    id: 'complaint.form.backToComplaintsOverview',
    defaultMessage: 'Back to My Complaints',
  },
  complaintDetailsPage: {
    id: 'complaint.details.page.seo.title',
    defaultMessage: 'Complaint details page',
  },
  addComplaintTitle: {
    id: 'complaints.add.title',
    defaultMessage: 'File complaint',
  },
  searchForAnOrder: {
    id: 'complaints.add.orderSearch.placeholder',
    defaultMessage: 'Search for an order',
  },
  noComplaints: {
    id: 'complaints.list.empty',
    defaultMessage: 'No Complaints to display',
  },
  lineItemsValidationError: {
    id: 'complaint.form.error.lineitems',
    defaultMessage: 'Please select at least one line item.',
  },
  quantitiesValidationError: {
    id: 'complaint.form.error.quantity',
    defaultMessage: 'Please enter complaint quantity.',
  },
  causeOfComplaintValidationError: {
    id: 'complaint.form.error.cause',
    defaultMessage: 'Please select a cause of complaint.',
  },
  descriptionValidationError: {
    id: 'complaint.form.error.description',
    defaultMessage: 'Please enter a description.',
  },
  resolutionValidationError: {
    id: 'complaint.form.error.resolution',
    defaultMessage: 'Please select a desired solution option.',
  },
});
